import { render, staticRenderFns } from "./SpectatingGames.vue?vue&type=template&id=ddec36ee&scoped=true&"
import script from "./SpectatingGames.vue?vue&type=script&lang=js&"
export * from "./SpectatingGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddec36ee",
  null
  
)

export default component.exports